import { AiOutlineArrowRight } from "react-icons/ai";
import { Label, PromotionModeEnum } from "components";

import defaultPhoto from "assets/images/default-photo.png";
import "./ContentListItem.scss";
import { Link } from "components/LanguageChanger";

// import { BranchInfo } from "views/public/Branch/BranchInfo";

interface ContentListItemProps {
  title: string;
  subtitle: string;
  image?: string;
  region?: string;
  category_id?: number | null;
  link: string;
  state?: { page: number };
  promotion?: {
    promotionMode: PromotionModeEnum;
    value?: string;
  };
}

export const ContentListItem = ({
  title,
  subtitle,
  image,
  link,
  state,
  region,
  promotion,
  category_id
}: ContentListItemProps) => {
  return (
    <Link to={link} state={state} className="content-list-item">
      {region && <Label className="content-list-item__label">{region}</Label>}
      {promotion && (
        <Label.PromotionLabel promotionMode={promotion.promotionMode}>
          {promotion.value}
        </Label.PromotionLabel>
      )}
      <div className="content-list-item__image-wrapper">
        {/* {category_id && (
          <div className="content-list-item__image-wrapper__category">
            კატეგორია{category_id}
          </div>
        )} */}
        {/* {region && (
          <div className="branchTitle">
            {" "}
            <span className="titleItem"> {region} </span>{" "}
          </div>
        )} */}
        {image ? (
          <img src={image} alt="contet-list-item-alt" loading="lazy" />
        ) : (
          <img src={defaultPhoto} alt="default" loading="lazy" />
        )}
      </div>
      <div className="content-list-item__content">
  {title && (
    <div className="content-list-item__title">
      {title}
    </div>
  )}
  <div className="content-list-item__bottom" style={!title ? { marginTop: '10px' } : {}}>
    <span
      className="subtitle"
      style={{ fontSize: !title ? '1.3rem' : '1rem' }}
    >
      {subtitle}
    </span>
    <div className="icon">
      <AiOutlineArrowRight />
    </div>
  </div>
</div>

    </Link>
  );
};
